import React, {Component} from 'react'
import {Input, message, Modal} from "antd"
import {markItemTransferred} from "../../../services/api/3dApi"

class BatchesMarkTransferred extends Component {
    state = {
        inputValue: '',
        valueTam: '',
        completed: false,
        loading: false,
        timeKeyStart: 0,
        timeKeyEnd: 0,
        strScan: ''
    }

    _input = React.createRef()

    _onSubmit = (e) => {
        e.preventDefault()
        const {valueTam} = this.state

        const check = /^#\d+_/.test(valueTam)

        this.setState({
            inputValue: check ? valueTam : '',
            valueTam: '',
            strScan: valueTam,
            completed: true
        }, () => {
            const valueFormatted = valueTam.trim().replace(/^#/, '')

            if (!valueFormatted) {
                return null
            }

            check && this._rqPrintAction(valueFormatted)
        })
    }

    _handleChange = e => {
        let {value} = e.target
        const {valueTam, strScan} = this.state

        if (value.length > strScan.length) {
            value = value.slice(value.indexOf(strScan) + strScan.length)
        }

        this.setState({
            inputValue: '',
            completed: false,
            valueTam: valueTam + value,
        })
    }

    _rqPrintAction = async (value) => {
        try {
            const payload = {
                itemNumber: value,
            }

            const {data: response} = await markItemTransferred(payload)

            const {success, error} = response

            if (!success) {
                return this.setState({
                    loading: false,
                    valueTam: ''
                }, () => {
                    Modal.error({
                        title: 'Lỗi',
                        content: error,
                        onOk: this._resetScanInput(),
                        okText: 'Đóng'
                    })
                })
            }

            this.setState({
                inputValue: '',
                loading: false,
                valueTam: '',
            })

            message.success('Đánh dấu đã ép thành công!')
        } catch (e) {
            this.setState({
                loading: false
            }, () => {
                Modal.error({
                    title: 'Lỗi',
                    content: e.message,
                    onOk: this._resetScanInput(),
                    okText: 'Đóng'
                })
            })
        } finally {
            this._input.current.focus()
        }
    }

    _onPaste = (e) => {
        //e.preventDefault()
    }

    _resetScanInput = () => {
        this.setState({
            inputValue: '',
            valueTam: '',
        }, () => {
            this._input.current.focus()
        })
    }

    render() {
        const {inputValue, loading} = this.state

        return (
            <div className='PackagePrintedPage'>
                <div className="position-relative">
                    <form onSubmit={this._onSubmit}>
                        <Input onPaste={this._onPaste} onChange={this._handleChange} value={inputValue} size='large'
                               ref={this._input}/>
                        {loading && (
                            <i className="position-absolute fa fa-spinner fa-spin"/>
                        )}
                        {inputValue && (
                            <i className="position-absolute fa fa-close cursor-pointer text-dark"
                               onClick={this._resetScanInput}/>
                        )}
                    </form>
                </div>
            </div>
        )
    }

}

export default BatchesMarkTransferred
